import { CatalogItemType } from '@common/model/catalog/item/type';
import { ModalViewProps } from '@cp/ds/src/components/modalView';
import { SwipeableCarouselWithAssessmentProps } from '@cp/ds/src/components/swipeableCarouselWithAssessment';
import { CatalogItemViewBaseProps } from '../../model';

export enum CatalogItemModalViewType {
  Single,
  List,
}

interface CatalogItemModalViewSingleProps {
  type: CatalogItemModalViewType.Single;
  viewProps: CatalogItemViewBaseProps;
}

interface CatalogItemModalViewListProps<ItemData> {
  type: CatalogItemModalViewType.List;
  viewProps: SwipeableCarouselWithAssessmentProps<ItemData>;
}

export type CatalogItemModalViewProps<ItemData> = Omit<ModalViewProps, 'config'> & {
  catalogItemType: CatalogItemType;
} & (CatalogItemModalViewSingleProps | CatalogItemModalViewListProps<ItemData>);
